import { CHAR_LIMITS } from "./constants";
export const ERROR_MESSAGES = {
  eventName: {
    required: "Please enter an event name",
    specialChar: "Name contains special character we do not support",
    emojiNotAllowed: "Emojis are not allowed",
    tooShort: "Please enter a valid event name greater than 1 character",
    chooseStartDateTime: "Please choose a start date and time",
    chooseEndDateTime: "Please choose an end date and time",
    chooseEventType: "Please choose an event type",
    chooseEventMode: "Please choose an event mode",
    chooseEventCurrency: "Please choose an event currency",
    eventStartTime: "Start date/time cannot be greater than the End date/time",
    eventEndTime: "End date/time cannot be earlier than the Start date/time",
  },
  eventShortName: {
    required: "Please provide a short name",
    valid: "Please provide a valid short name",
    alphaNumericRecommendation: "We recommend using alphabets in your event URL for easier recognition",
    emojiNotAllowed: "Emojis are not allowed",
  },
  venue: {
    specialChar: "Venue contains special characters which we do not support",
    required: "Please enter event Venue",
    tooShort: "Please enter a valid event city greater than 1 character",
  },
  country: {
    required: "Please enter event Country",
    specialChar: "Country contains special characters which we do not support",
    tooShort: "Please enter a valid event country greater than 1 character",
  },
  city: {
    required: "Please enter event City",
    specialChar: "City contains special characters which we do not support",
    tooShort: "Please enter a valid event city greater than 1 character",
  },
  state: { required: "Please enter event State" },
  eventLiveLink: { required: "Please enter a valid URL" },
  ticketRequired: { required: "Please attach atleast one ticket" },
  dateTime: {
    startGreaterThanEnd: "Start date cannot be greater than End date",
    sameDayError: "For single day event, the end time should be later than the start time",
  },
  additionalVenueDetails: {
    charLimitExceeded: "You have reached maximum character limit",
    englishOnly: "The platform supports English language only. Kindly provide your details in English.",
  },
  eventUrl: {
    required: "Please provide an event name",
    specialChar: "For event URL, special characters and spaces are not allowed (only alphanumerics & hyphens are allowed)",
  },
  phoneNumber: {
    name: "Please provide name",
    validName: "Please enter a valid name",
    required: "Please provide phone number",
    typeError: "Phone number should only contain numbers",
    positive: "Enter a valid phone number",
    integer: "Enter a valid phone number",
    minLength: "Phone number should contain at least 5 digits",
    maxLength: "Phone number should not exceed 20 digits",
  },
  ticket: {
    required: "Please enter ticket name",
    valid: "Please enter a valid ticket name",
    unique: "Please enter a unique ticket name",
    ticketLessEqual: "Please enter a valid date and time which is less than or equal to event's end date and time",
    ticketStartTime: "Please enter a valid date and time which is less than end date and time",
    ticketEndTime: "Please enter a valid date and time which is greater than start date and time",
    donationticketMin: "Please enter a valid minimum price greater than 10",
    donationticketMax: "Minimum price should be less than maximum price",
    donationticketMinGreater: "Please enter a valid minimum price, greater than 9",
    donationticketMaxGreater: "Please enter a valid minimum price greater than 10",
    donationticketMinMaxGreater: "Maximum price should be greater than minimum price",
    ticketPrice: "Please enter ticket price",
    ticketPriceMin: "Please enter a valid ticket price greater than 0",
    numberOfTickets: "Please enter a valid Maximum Limit",
    ticketsDescription: "You have reached maximum character limit",
  },
  benefitDimension: {
    lengthRequired: "Length is required.",
    lengthValid: "Length must be a number.",
    lengthGreater: "Length must be greater than 0.",
    widthRequired: "Width is required.",
    widthValid: "Width must be a number.",
    widthGreater: "Width must be greater than 0.",
    unit: "Unit is required.",
  },
  benefit: {
    required: "Please enter benefit name",
    valid: "Allowed characters are alphanumeric and these symbols ('-', ':', '(', ')', '[', ']', '|', ',', '#', '/', '<', '>', '.', '&', '@', '+', '_')",
    greater: `Please enter less than ${CHAR_LIMITS.benefit.name} characters`,
    descRequired: "Please enter description",
    descGreater: `Please enter less than ${CHAR_LIMITS.benefit.descMax} characters`,
  },
  benefitTicket: {
    urlNameRequired: "Please provide Ticket Name",
    urlNameTooShort: "The URL name is too short. Please ensure it has a minimum length of 5 characters to proceed.",
    ticketsConfigurationRequired: "Please select at least one ticket",
    ticketsConfigurationInvalid: "A minimum of one ticket is required. Please adjust your selection.",
    ticketUrlRequired: "Registration URL is required.",
    ticketUrlInvalid: "Please provide a valid registration URL.",
  },
};

export const ErrMessages = {
  DEFAULT_ERROR_MESSAGE: "Something went wrong",
  INTERNAL_SERVER_ERROR: "Internal Server Error",
  MAXIMUM_LIMIT_MESSAGE: "Maximum 10 files allowed"
};

export const CrudMessages = {
  DELETE_MESSAGE: "Deleted Successfully",
  UPDATE_MESSAGE: "Updated Successfully",
  ADDED_MESSAGE: "Added Successfully",
  UPLOAD_MESSAGE: "Uploaded Successfully",
}

export const SUCCESS_MESSAGES = {
  FILE_MESSAGE: "File uploaded successfully",
  UPDATE_MESSAGE: "Updated Successfully",
  ADDED_MESSAGE: "Added Successfully",
}

